import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from '../survey-state.model';

export const HEALTH_HANDLERS = [
  on(
    ManageSurveyActions.loadSurveyHealth,
    (state): ManageSurveyState => ({
      ...state,
      healthMetricsLoading: true,
      healthMetricsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadSurveyHealthSuccess,
    (state, { healthMetrics }): ManageSurveyState => ({
      ...state,
      healthMetrics,
      healthMetricsLoading: false,
      healthMetricsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadSurveyHealthFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      healthMetrics: [],
      healthMetricsLoading: false,
      healthMetricsError: error,
    }),
  ),

  on(
    ManageSurveyActions.loadRemainingHours,
    (state): ManageSurveyState => ({
      ...state,
      remainingHoursLoading: true,
      remainingHoursError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadRemainingHoursSuccess,
    (state, { remainingHours }): ManageSurveyState => ({
      ...state,
      remainingHours,
      remainingHoursLoading: false,
      remainingHoursError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadRemainingHoursFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      remainingHours: null,
      remainingHoursLoading: false,
      remainingHoursError: error,
    }),
  ),
];
